import React from 'react';
import PropTypes from 'prop-types';

import {
  AlertBlockWarning,
  ButtonPrimary,
  Typography,
  IllustrationNewBusiness,
} from '@klarna/bubble-ui';
import { VerticalRhythm } from 'mage-components';
import { Alert } from 'moet-core';

import Instructions from './Instructions';

const tPrefix = 'products-fe.pages.whats_next_page.ready_to_connect';

const Connection = ({ t }) => (
  <>
    <Typography textToken="text-style/headings/blocks/bold/primary">
      {t(`${tPrefix}.title`)}
    </Typography>
    <VerticalRhythm spacing={6} />
    <Typography textToken="text-style/text/paragraphs/tall/regular">
      {t(`${tPrefix}.subtitle`)}
    </Typography>
    <VerticalRhythm spacing={6} />
    <AlertBlockWarning
      iconType={() => null}
      title={
        <Typography textToken="text-style/text/paragraphs/tall/regular">
          {t(`${tPrefix}.status_messsage.title`)}
        </Typography>
      }
      content={[
        <>
          <VerticalRhythm spacing={4} />
          <Typography textToken="text-style/text/super-paragraphs/body/regular">
            {t(`${tPrefix}.status_messsage.subtitle`)}
          </Typography>
        </>,
      ]}
    />
    <VerticalRhythm spacing={{ mobile: 6, tablet: 10 }} />
    <Instructions />
    <VerticalRhythm spacing={{ mobile: 6, tablet: 10 }} />
  </>
);

Connection.propTypes = {
  t: PropTypes.func.isRequired,
};

const tPrefixNewIg = `${tPrefix}_new_ig`;

const ConnectionWithNewIntegrationGuides = ({ t }) => {
  const onClick = () => window.location.assign('/integration-guides');

  return (
    <>
      <IllustrationNewBusiness />
      <VerticalRhythm spacing={6} />
      <Typography textToken="text-style/headings/blocks/bold/primary">
        {t(`${tPrefixNewIg}.title`)}
      </Typography>
      <VerticalRhythm spacing={6} />
      <Typography textToken="text-style/headings/blocks/medium/tertiary">
        {t(`${tPrefixNewIg}.subtitle`)}
      </Typography>
      <VerticalRhythm spacing={12} />
      <div style={{ maxWidth: 200 }}>
        <ButtonPrimary tabIndex={0} loading={false} onClick={onClick}>
          {t(`${tPrefixNewIg}.buttons.connect`)}
        </ButtonPrimary>
      </div>
      <VerticalRhythm spacing={12} />
      {t(`${tPrefixNewIg}.additional_info`) && (
        <Alert type="warning" content={t(`${tPrefixNewIg}.additional_info`)} />
      )}
    </>
  );
};

ConnectionWithNewIntegrationGuides.propTypes = {
  t: PropTypes.func.isRequired,
};

export { Connection, ConnectionWithNewIntegrationGuides };
